import ProjectPropertyLookup, {SourceType} from "./project-property-lookup";
import ProjectSession from "../project-session";

// const debug = "TasksStatusesLookup"
const debug = false

export default class TasksStatusesLookup extends ProjectPropertyLookup {

    // method to get task statuses if overridden otherwise
    // they'll be taken from task type statuses
    getForTask() {
        let res = [];

        // 1. check if project has property and retrieve task statuses
        if (this.project && !!this.project.taskStatusesOverride) {
            res = this.getProjectTasksStatuses(this.project);
            this.sourceType = SourceType.CUSTOM;
            debug && console.log(debug, "project itself statuses = ", res)
        }

        // 2. if task statuses not found yet check parents
        if (res.length === 0) {
            _.some(this.findAllParents(), project=>{
                res = this.getProjectTasksStatuses(project);

                // if result found then inherited from current project
                if (res.length !== 0) {
                    this.sourceType = SourceType.INHERITED;
                    this.sourceProjectId = project.id;
                    return true; // break iteration loop
                }
            });
            debug && console.log(debug, "project inherited statuses = ", res)
        }

        // 3. if still not found then check project template
        if (res.length === 0) {
            let template : ProjectSession | null;
            if (this.project) {
                const templateId = this.project.localTemplateId ? this.project.localTemplateId : this.project.sharedTemplateId;
                template = gd.session.projects.get(templateId);
                if (template) res = this.getProjectTasksStatuses(template);
            }

            // if result found then inherited from template
            if (res.length !== 0) {
                this.sourceType = SourceType.INHERITED;
                this.sourceProjectId = template!.id;

                debug && console.log(debug, "statuses inherited from template = ", res)
            }
        }

        return res;
    }

    // method to get all task statuses for project and
    // if not overridden then collect statuses from all project task types
    get() {
        let res = this.getForTask();

        // 4. if task statuses still not found return default task statuses
        if (res.length === 0) {
            res = this.getDefaultTasksStatuses();
            this.sourceType = SourceType.GENERIC;
        }

        return res;
    }

    getProjectTasksStatuses(project:any) {
        let res:any[] = [];

        // we do it because statuses may not present in session or be deleted
        _.map(project.taskStatusesOverride, id=>{
            const status = gd.session.statuses.get(id);
            if (status && !status.isDeleted) res.push(id)
        });

        return res;
    }

    getDefaultTasksStatuses() {
        let taskTypeStatuses:any[] = [];

        // get all task types for project
        const taskTypesIds = gd.session.projects.get(this.projectId)!.getInheritedTaskTypes();

        // get all statuses from task types
        taskTypesIds.map((taskTypeId:ID)=>{
            let taskType = gd.session.taskTypes.get(taskTypeId);
            _.map(taskType?.statuses?.models, (taskStatus:any)=>{
                taskTypeStatuses.push(taskStatus);
            })
        });

        taskTypeStatuses = _.orderBy(taskTypeStatuses, [
            ts=>ts.status.systemStatus,
            'sortPosition',
            ts=>ts.status.name
        ], ['asc','asc','asc']);

        return _.uniq(taskTypeStatuses.map(ts=>ts.statusId));
    }
}